<div class="animated fadeIn container"
   *ngIf="partsAmount && partsValue && commissionNet && commissionTax && total && userBalance">

    <h3 class="fs-24 text-center fw-bold cl-primary-modal mt-5">Compra de participaciones</h3>
    <p class="w-75 m-auto mt-3 text-center fs-14 cl-secondary-modal">Estas a punto de comprar
      <span class="cl-third-modal fw-sbold">
         {{ this.partsAmount }} {{ this.partsAmount > 1 ? 'participaciones' : 'participación'}}
      </span> en <strong>{{ devName || 'en el proyecto'}}</strong> por un total de
      <span class="cl-third-modal fw-sbold">{{total | currency: '$'}} MXN</span>
   </p>

    <div class="details-purchase mt-4 mb-5 m-auto d-block">
        <h3 class="m-0 header-modal text-center fs-16 p-2 w-60">Detalles de la compra</h3>
        <div class="bg-white body-modal p-3 w-60">
            <div class="d-flex align-items-center justify-content-between">
                <p class="m-0 mb-2">Monto:</p>
                <p class="m-0 mb-2">{{ partsValue | currency: '$' }} MXN</p>
            </div>
            <div class="d-flex align-items-center justify-content-between">
                <p class="m-0 mb-2">Comisión:</p>
                <p class="m-0 mb-2">{{ commissionNet | currency: '$'}} MXN</p>
            </div>
            <div class="d-flex align-items-center justify-content-between">
                <p class="m-0 mb-2">I.V.A:</p>
                <p class="m-0 mb-2">{{ commissionTax | currency: '$'}} MXN</p>
            </div>
            <hr>
            <div class="d-flex align-items-center justify-content-between">
                <p class="fw-bold">Total</p>
                <p class="fw-bold">{{ total | currency: '$'}} MXN</p>
            </div>
        </div>
        <div class="w-60">
            <div class="d-flex justify-content-evenly doble mt-4">
              <button mat-button class="invert" (click)="cancel()">
                Cancelar
              </button>
              <button mat-button class="cancel" (click)="purchaseAction()">
                Comprar
              </button>
            </div>
        </div>
    </div>

</div>
